import { SegmentsPageLoader } from "app/pages/segments/segmentsPageLoader";

import { AlertPageContainer } from "../../ui/alert-page-container";

export const PageLoadingState = () => {
    return (
        <AlertPageContainer>
            <SegmentsPageLoader />
        </AlertPageContainer>
    );
};
